import React, { useEffect, useMemo, useState } from 'react';
import { useAppSelector } from '../../../store';
import { API_USER } from '../../../api/user';
import { ENUM_BONUS_LABEL, ENUM_CUS_EVENT } from '../../../enums/enums';
import useToast from '../../useToast';
import { dispatchCusEvent } from '../../../utils';
import { setUpdateBonus } from '../../../store/apps/userSlice';
import { useDispatch } from 'react-redux';

// TODO сделать рефакт, что бы в changeFieldPackage не передавать валюту
// TODO сделать рефакт, что бы options записывался при дефолтном создании

export default function useEditBonusWelcome(groupId) {
  const { successToast, infoToast } = useToast();
  const type = ENUM_BONUS_LABEL.welcome;

  const dispatch = useDispatch();
  const bonusWelcome = useAppSelector((state) => state.user.bonus?.[groupId]?.[type]);
  const group = useAppSelector((state) => state.user.group.hash?.[groupId]);
  const [welcomeStruct, setWelcomeStruct] = useState(
    Array.isArray(bonusWelcome) ? {} : bonusWelcome || {}
  );
  const [updateSubgroups, setUpdateSubgroups] = useState(false);
  const [selectCurrency, setSelectCurrency] = useState(group?.currency);
  const [activeBonus, setActiveBonus] = useState(0);

  const useFS = useMemo(() => {
    if (!welcomeStruct?.packets) return false;

    // Ищем хотя бы один пакет, где есть campaignId для selectCurrency
    return welcomeStruct.packets.some((pkg) =>
      pkg?.values?.[selectCurrency]?.some?.((el) => el.campaignId)
    );
  }, [welcomeStruct, selectCurrency]);

  const welcomeEnable = welcomeStruct?.enabled;
  const expireDays = welcomeStruct?.expireDays;
  const packets = welcomeStruct?.packets;
  const defaultCurrency = group?.currency;
  const lifetimeDays = welcomeStruct?.lifetimeDays || 0;
  const lockSetting = welcomeStruct?.updateLocked;
  const useCasinoTax = welcomeStruct?.useCasinoTax;
  const saveDisabled = !packets?.length;
  const autoActive = welcomeStruct?.options?.[selectCurrency]?.userActivate;

  const getUseCurrencyList = (packages) => {
    const currencies = new Set();

    packages.forEach((item) => {
      if (item.values) {
        Object.keys(item.values).forEach((currency) => currencies.add(currency));
      }
    });

    return Array.from(currencies);
  };

  const changeSubgroup = () => setUpdateSubgroups((prev) => !prev);
  const changeEnable = () => setWelcomeStruct((prev) => ({ ...prev, enabled: !welcomeEnable }));
  const changeLifetimeDays = (val) => setWelcomeStruct((p) => ({ ...p, lifetimeDays: val }));
  const changeUseCasinoTax = () => setWelcomeStruct((p) => ({ ...p, useCasinoTax: !useCasinoTax }));
  const changeLockSetting = () => setWelcomeStruct((p) => ({ ...p, updateLocked: !lockSetting }));

  const getPackageInfo = (packageId, currency, currencyIndx) => {
    return packets[packageId]?.values?.[currency]?.[currencyIndx] || {};
  };

  const changeFieldPackage = (packageId, currency, currencyIndx, name, value) => {
    setWelcomeStruct((prev) => {
      const newWelcome = JSON.parse(JSON.stringify(prev));
      if (!newWelcome.packets) newWelcome.packets = [];
      if (!newWelcome.packets[packageId]?.values?.[currency]) {
        newWelcome.packets[packageId].values[currency] = [];
      }
      const currentField = newWelcome.packets[packageId].values[currency][currencyIndx];
      if (!currentField) newWelcome.packets[packageId].values[currency][currencyIndx] = {};
      newWelcome.packets[packageId].values[currency][currencyIndx][name] = value;

      return newWelcome;
    });
  };

  const addNewPackage = () => {
    setWelcomeStruct((prev) => {
      const newWelcome = JSON.parse(JSON.stringify(prev));
      const packetsLength = newWelcome.packets?.length;

      if (packetsLength) {
        const tempPackage = newWelcome.packets[packetsLength - 1];
        newWelcome.packets[packetsLength] = tempPackage;
      } else {
        newWelcome.packets = [
          {
            values: {
              [defaultCurrency]: [
                {
                  minDeposit: 1,
                  maxDeposit: 1,
                  percent: 1,
                  wager: 1,
                  cashout: 1,
                  toDeposit: false,
                  campaignId: undefined
                }
              ]
            }
          }
        ];
      }

      return newWelcome;
    });
  };

  const onDeleteRow = (packageId, currency, currencyIndx) => {
    setWelcomeStruct((prev) => {
      const newWelcome = JSON.parse(JSON.stringify(prev));
      const values = newWelcome.packets[packageId].values[currency];

      delete values[currencyIndx];
      newWelcome.packets[packageId].values[currency] = values.filter((el) => el);

      return newWelcome;
    });
  };

  const onDeletePackage = (packageId) => {
    setWelcomeStruct((prev) => {
      const newWelcome = JSON.parse(JSON.stringify(prev));
      delete newWelcome.packets[packageId];
      newWelcome.packets = newWelcome.packets.filter((el) => el);
      return newWelcome;
    });
  };

  const updateExpireDays = (expireDays) => {
    setWelcomeStruct((prev) => ({ ...prev, expireDays: +expireDays }));
  };

  const onSave = () => {
    const updateStore = () => {
      // если успех произошёл без ИД - то это создание
      if (!welcomeStruct.id) {
        dispatchCusEvent(ENUM_CUS_EVENT.getBonusList, { groupId });
        setUpdateSubgroups(false);
        return;
      }
      const bonusData = { id: groupId, bonusName: type, data: welcomeStruct };
      dispatch(setUpdateBonus(bonusData));
    };

    const newWelcome = JSON.parse(JSON.stringify(welcomeStruct));
    const options = newWelcome.options || {};

    // проверяем все валюты которые используем и добавляем false
    const allUseCurrency = getUseCurrencyList(newWelcome.packets || []);
    console.log('allUseCurrency', allUseCurrency);

    allUseCurrency.forEach((currency) => {
      if (!options[currency]) options[currency] = {};

      // if (!options[currency]?.userActivate) {
      // options[currency].userActivate = false;
      // }

      options[currency].userActivate = false;
    });

    newWelcome.options = options;

    const updateData = {
      groupId: +groupId,
      updateSubgroups,
      bonusLabel: type,
      bonusData: newWelcome
    };

    API_USER.group.bonus
      .update(updateData)
      .then((e) => {
        updateStore();
        successToast('Information updated successfully');
      })
      .catch(console.error);
  };

  useEffect(() => {
    if (!bonusWelcome || Array.isArray(bonusWelcome)) return;
    setWelcomeStruct(bonusWelcome);
  }, [bonusWelcome]);

  return {
    welcomeEnable,
    updateSubgroups,
    expireDays,
    packets,
    lifetimeDays,
    autoActive,
    saveDisabled,
    useCasinoTax,
    lockSetting,
    selectCurrency,
    activeBonus,
    setActiveBonus,
    setSelectCurrency,
    changeLockSetting,
    changeLifetimeDays,
    getPackageInfo,
    changeEnable,
    changeSubgroup,
    changeFieldPackage,
    changeUseCasinoTax,
    addNewPackage,
    onDeleteRow,
    onDeletePackage,
    updateExpireDays,
    onSave
  };
}
